export interface TGetUserActivityLogsRequest extends Record<string, any> {
    nexId?: string;
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
    actionType?: UserActionType;
}

export interface TGetUserActivityLogsResponse {
    data: TUserActivityLog[];
    count: number;
    currentPage: number;
    lastPage: number;
}

export interface TGetUserActivityLogDetailRequest {
    id: string;
}

export interface TGetUserActivityLogDetailResponse {
    id: string;
    userId: string;
    nexId: string;
    deviceId: string;
    actionType: UserActionType;
    createdAt: string;
    details: IUserActivityLogDetailItem[];
}

export interface TUserActivityLog {
    id: string;
    userId: string;
    nexId: string;
    deviceId: string;
    actionType: UserActionType;
    createdAt: string;
}

export enum UserActivityLogDetailType {
    TRANSACTION_ID = 'TRANSACTION_ID',
    TRANSACTION_AMOUNT = 'TRANSACTION_AMOUNT',
    MERCHANT_IN_PAYMENT = 'MERCHANT_IN_PAYMENT',
    DESTINATION_BANK_CODE = 'DESTINATION_BANK_CODE', // for send to bank txn
    DESTINATION_BANK_NAME = 'DESTINATION_BANK_NAME', // for send to bank txn
    DESTINATION_ACCOUNT_NAME = 'DESTINATION_ACCOUNT_NAME', // for send to bank txn
    DESTINATION_ACCOUNT_NUMBER = 'DESTINATION_ACCOUNT_NUMBER', // for send to bank txn
    WALLET_RECIPIENT_ID = 'WALLET_RECIPIENT_ID', // for send to friends txn
    WALLET_RECIPIENT_NEX_ID = 'WALLET_RECIPIENT_NEX_ID', // for send to friends txn
}

export interface IUserActivityLogDetailItem {
    name: UserActivityLogDetailType;
    value: string | number;
}

export enum UserActionType {
    ALL = 'ALL',
    VIEW_BALANCE = 'VIEW_BALANCE',
    VIEW_TRANSACTIONS_LIST = 'VIEW_TRANSACTIONS_LIST',
    VIEW_VA_TOP_UP_SCREEN = 'VIEW_VA_TOP_UP_SCREEN',
    LINKING_ACCOUNT_FOR_DIRECT_DEBIT = 'LINKING_ACCOUNT_FOR_DIRECT_DEBIT',
    DELETE_ACCOUNT_FOR_DIRECT_DEBIT = 'DELETE_ACCOUNT_FOR_DIRECT_DEBIT',
    PAYMENT_IN_MERCHANT = 'PAYMENT_IN_MERCHANT',
    SEND_TO_BANK = 'SEND_TO_BANK',
    SEND_TO_FRIENDS = 'SEND_TO_FRIENDS',
    TOP_UP_VIA_DIRECT_DEBIT = 'TOP_UP_VIA_DIRECT_DEBIT',
    ENTER_WRONG_PIN = 'ENTER_WRONG_PIN',
    ENTER_CORRECT_PIN = 'ENTER_CORRECT_PIN',
    SUBMIT_KYC = 'SUBMIT_KYC',
}
